/*!
 * Main.js
 */

import Scripts from './scripts.js';

// 변수, 공통 플러그인 초기화 후 템플릿 노출
(function () {
  window.addEventListener('DOMContentLoaded', () => {
    if (typeof Scripts !== 'undefined') {
      const scripts = new Scripts();
    }
  });
})();
